import React from 'react'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';

const LoadingOverlay = () => {

  const { pageContentsLoaded } = useStore(state =>({
    pageContentsLoaded : state. pageContentsLoaded,
  }), shallow);

  return (
    <div className={`loading-overlay ${pageContentsLoaded ? "hide":""}`}></div>
    // <div className="loading-overlay">{pageContentsLoaded}</div>
  )
}


export default LoadingOverlay